import * as React from 'react'
import * as Tooltip from 'react-tooltip'
import { IPaymentLine } from '@getgreenline/homi-shared'
import { Currency } from '../../../components/Currency'
import { LoyaltyModels } from '@getgreenline/loyalties'

interface Props {
  paymentLine: IPaymentLine
  loyaltyData?: LoyaltyModels.ILoyaltyData
}

export class PaymentLine extends React.Component<Props, {}> {
  private get loyaltyPointDeducted(): number | undefined {
    const { paymentLine, loyaltyData } = this.props

    const paymentLineDiscountId = paymentLine.discountId

    if (!paymentLineDiscountId || !loyaltyData) {
      return undefined
    }

    const loyaltyPointDeducted = loyaltyData.mappedDiscountIdToAmount.get(paymentLineDiscountId)

    return loyaltyPointDeducted
  }

  render() {
    const { paymentLine } = this.props

    let unitString: string
    if (paymentLine.inventorySubtracted) {
      if (paymentLine.unit === 'gram') {
        unitString = `${paymentLine.inventorySubtracted} g`
      } else {
        unitString = paymentLine.inventorySubtracted.toString()
      }
    } else {
      unitString = paymentLine.units.toString()
    }

    if (paymentLine.type === 'discount' || paymentLine.type === 'loyalty') {
      return (
        <tr>
          <td>{paymentLine.productName}</td>
          <td></td>
          <td className='text-right'>
            <Currency centValue={paymentLine.discountPrice} />

            {this.loyaltyPointDeducted !== undefined && (
              <>
                <br />
                {this.loyaltyPointDeducted.toLocaleString('en-CA')} points
              </>
            )}
          </td>
        </tr>
      )
    } else {
      return (
        <React.Fragment>
          <tr>
            <td>
              <span>
                <div>SKU: {paymentLine.sku || '-'}</div>
                {paymentLine.productName}
                {paymentLine.batchNumber !== null && <div>Lot: {paymentLine.batchNumber}</div>}
              </span>
              {paymentLine.barcode !== null && (
                <>
                  <span
                    className='fa fa-barcode text-muted ml-3'
                    data-tip
                    data-for={paymentLine.id + '-barcode'}
                  />
                  <Tooltip id={paymentLine.id + '-barcode'} place='right' effect='solid'>
                    {paymentLine.barcode}
                  </Tooltip>
                </>
              )}
            </td>
            <td className='text-right' style={{ whiteSpace: 'nowrap' }}>
              x {unitString}
            </td>
            <td className='text-right'>
              <Currency centValue={paymentLine.price} />
            </td>
          </tr>
          {paymentLine.discountPrice ? (
            <tr>
              <td style={{ borderTop: '1px solid #fff' }}>{paymentLine.discountMessage}</td>
              <td colSpan={2} style={{ borderTop: '1px solid #fff' }} className='text-right'>
                <Currency centValue={paymentLine.discountPrice} />

                {this.loyaltyPointDeducted !== undefined && (
                  <>
                    <br />
                    {this.loyaltyPointDeducted.toLocaleString('en-CA')} points
                  </>
                )}
              </td>
            </tr>
          ) : undefined}
          {paymentLine.depositFee ? (
            <tr>
              <td style={{ borderTop: '1px solid #fff' }}>Deposit Fees</td>
              <td style={{ borderTop: '1px solid #fff' }} className='text-right'></td>
              <td style={{ borderTop: '1px solid #fff' }} className='text-right'>
                <Currency centValue={paymentLine.depositFee} />
              </td>
            </tr>
          ) : undefined}
        </React.Fragment>
      )
    }
  }
}
